@if (pendingLink$ | async) {
  <div class="link-modal-overlay">
    <div class="dvat-modal link-modal">
      <div class="dvat-modal__header">
        <h3 class="dvat-modal__title">Link openen?</h3>
      </div>
      <div class="dvat-modal__body">
        <p>Let op: Je verlaat de AI assistent. De volledige pagina wordt geopend in een nieuw venster.</p>
      </div>
      <div class="dvat-modal__footer">
        <button class="dvat-button dvat-button--primary" type="button" (click)="confirm()">
          Link openen
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M2 12L12 2M12 2H5M12 2V9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="dvat-button dvat-button--textual" type="button" (click)="cancel()">
          Terug naar chat
        </button>
      </div>
    </div>
  </div>
}
